module.exports = __webpack_public_path__ + "static/media/SF_bm_sekundaerlogo_postale_nordland_pos.08dea9d7.png";